import getStatusSettings from "./getStatusSettings"

const getStatusName = id => {
    const statusSettings = getStatusSettings()

    if(statusSettings.items.hasOwnProperty(id)) {
        return statusSettings.items[id].name
    } else {
        return statusSettings.items.undefined.name
    }
}

export default getStatusName